/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * This is the Magnifier component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Magnifier({ title, ...props }) {
  return (
    <span className="svg svg-magnifier" {...props}>
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <title>{title}</title>
          <path
            d="M20,18.239l-4.151-4.151A8.612,8.612,0,0,0,17.61,8.805,8.751,8.751,0,0,0,8.805,0,8.751,8.751,0,0,0,0,8.805,8.751,8.751,0,0,0,8.805,17.61a8.612,8.612,0,0,0,5.283-1.761L18.239,20ZM2.516,8.805A6.228,6.228,0,0,1,8.805,2.516a6.228,6.228,0,0,1,6.289,6.289,6.228,6.228,0,0,1-6.289,6.289A6.228,6.228,0,0,1,2.516,8.805Z"
            fill="currentColor"
          />
        </svg>
      </span>
    </span>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Magnifier.propTypes = {
  title: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Magnifier.defaultProps = {
  title: 'Magnifier',
};

export default Magnifier;
